module.exports = __webpack_public_path__ + "static/media/Landscape.89ed5152.png";